import { useLocation, Outlet } from 'react-router-dom';
//
import MainNavbar from './MainNavbar';
import MainFooter from './MainFooter';

// ----------------------------------------------------------------------

export default function MainLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <>
      <MainNavbar />
      <div>
        <Outlet />
      </div>

      {!isHome ? (
        <MainFooter />
      ) : (
        <MainFooter />
        // <Box
        //   sx={{
        //     py: 5,
        //     textAlign: 'center',
        //     position: 'relative',
        //     bgcolor: 'background.default'
        //   }}
        // >
        //   <Container maxWidth="lg">
        //     <ScrollLink to="move_top" spy smooth>
        //       <Logo sx={{ mb: 1, mx: 'auto', cursor: 'pointer' }} />
        //     </ScrollLink>

        //     <Typography variant="caption" component="p">
        //       © All rights reserved
        //       <br /> made by &nbsp;
        //       <Link href="https://minimals.cc/">minimals.cc</Link>
        //     </Typography>
        //   </Container>
        // </Box>
      )}
    </>
  );
}
